var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4412 14H6.55885C4.79415 14 3.61768 13.1176 3.61768 11.0588V6.94118C3.61768 4.88235 4.79415 4 6.55885 4H12.4412C14.2059 4 15.3824 4.88235 15.3824 6.94118V11.0588C15.3824 13.1176 14.2059 14 12.4412 14Z",
    stroke: "#CB9C2D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4412 7.23535L10.6 8.70594C9.99413 9.18829 9.00001 9.18829 8.39413 8.70594L6.55884 7.23535",
    stroke: "#CB9C2D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/smsIcon.64b99a914bfd5f25886ea9295caa7ea6.svg";
export { ForwardRef as ReactComponent };